<!-- eslint-disable -->
<eca-monotron></eca-monotron>

<eca-monotron-body>
  <h1 class="eca-skip-link-focus-target" tabindex="-1">Local Scanning</h1>
  <eca-nav></eca-nav>
  <div class="eca-monotron-description-wrapper">
    <p class="eca-monotron-description">
      Please carefully review each document’s alerts and update or confirm as necessary to clear the alerts.
      Note that Score Input errors must be corrected in the answer document and rescanned.
      Once all alerts for a document have been cleared, the document will move to the Submit tab.
    </p>
  </div>

  <div class="filter-bar"
    [formGroup]="form">

    <div class="filter-group">
      <mat-form-field>
        <eca-search matInput
          placeholder="Search"
          formControlName="search"
          [disableAutocomplete]=true>
        </eca-search>
      </mat-form-field>
    </div>

    <div class="filter-group">
      <mat-button-toggle-group [multiple]="true"
        [hidden]="!(alertCount$ | async)"
        formControlName="alertTypes" >
        @if (hasBlankAlerts$ | async) {
          <mat-button-toggle value="blank">Blanks</mat-button-toggle>
        }
        @if (hasMultiAlerts$ | async) {
          <mat-button-toggle value="multi">Mults</mat-button-toggle>
        }
        @if (hasScoreInputAlerts$ | async) {
          <mat-button-toggle value="scoreInput">Score Inputs</mat-button-toggle>
        }
        @if (hasBiographicAlerts$ | async) {
          <mat-button-toggle value="biographic">Biographical</mat-button-toggle>
        }
        @if (hasSubmitAlerts$ | async) {
          <mat-button-toggle value="submit">Submit Error</mat-button-toggle>
        }
      </mat-button-toggle-group>
    </div>

    <div class="button-group">
      <button mat-button
        class="scan-button"
        color="primary"
        [disabled]="!selected.length"
        ecaThrottleClick
        (throttleClick)="clearSelectedAlerts()">
        Clear Alerts
      </button>
    </div>
  </div>


  @if (filteredPending$ | async; as filteredData) {
    <eca-alerts-table #alertsTable [data]="filteredData"
      (selected)="onSelection($event)">
    </eca-alerts-table>
    <eca-no-results
      [hidden]="filteredData.length !== 0">
    </eca-no-results>
  }
</eca-monotron-body>
